import { render, staticRenderFns } from "./details_carryout.vue?vue&type=template&id=eec09ff2&"
import script from "./details_carryout.vue?vue&type=script&lang=js&"
export * from "./details_carryout.vue?vue&type=script&lang=js&"
import style0 from "./details_carryout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports